module.exports = __webpack_public_path__ + "static/media/s.8e35ab79.png";